import { Grid } from "@mui/material";
import { styled, SxProps } from "@mui/material/styles";
import clsx from "clsx";
import {
  AppBarProps,
  AppBar as DefaultAppBar,
  Menu as DefaultMenu,
  Sidebar as DefaultSidebar,
  Error,
  ErrorProps,
  Inspector,
  Loading,
  MenuProps,
  SidebarProps,
  SkipNavigationButton,
} from "ra-ui-materialui";
import React, {
  ComponentType,
  ErrorInfo,
  Suspense,
  useContext,
  useEffect,
  useState,
} from "react";
import { TabbedForm } from "react-admin";
import { ErrorBoundary } from "react-error-boundary";
import { useMatch } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import ApplicationSummaryTabShowBody from "../applications/summary_tabs/ApplicationSummaryTabShowBody";
import CustomerSummaryTabShowBody from "../applications/summary_tabs/CustomSummaryTabShowBody";
import LoanSummaryTabShowBody from "../applications/summary_tabs/LoanSummaryTabShowBody";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";
import { logClientError } from "../utils/clientErrorLogger";

const CustomTabbedFormTab = styled(TabbedForm.Tab)(({ theme }) => ({
  minWidth: 0,
  textTransform: "none",
  fontWeight: "bold",
  opacity: 1,
  "&.Mui-selected": {
    background: "rgb(248, 249, 249)",
  },
}));

const CustomTabbedForm = styled(TabbedForm)(({ theme }) => ({
  "& .MuiTab-root": {
    minWidth: 0,
    textTransform: "none",
    fontWeight: "bold",
    opacity: 1,
    "&.Mui-selected": {
      backgroundColor: "#1976d2",
      color: "white",
    },
  },

  ".MuiCardContent-root": {
    background: "rgb(248, 249, 249)",
  },
  ".MuiCardContent-root:last-child": {
    paddingBottom: "10px",
  },
  "& .MuiTabs-root": {
    display: "none",
  },
}));

const TabbedFormContainer = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} />
);

export const HMLayout = (props: LayoutProps) => {
  const {
    appBar: AppBar = DefaultAppBar,
    appBarAlwaysOn,
    children,
    className,
    error: errorComponent,
    menu: Menu = DefaultMenu,
    sidebar: Sidebar = DefaultSidebar,
    ...rest
  } = props;

  const {
    openGlobalTabs,
    removeGlobalTabName,
    setRemoveGlobalTabName,
    addGlobalTab,
    removeGlobalTab,
  } = useContext(OpenTabsContext);
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | undefined>(undefined);

  const handleError = (error: Error, info: ErrorInfo) => {
    setErrorInfo(info);
    void logClientError({
      source: "react-error-boundary",
      error,
      extra: {
        componentStack: info.componentStack,
      },
    });
  };

  const [showBaseInfo, setShowBaseInfo] = useState(true);
  const [showRequirement, setShowRequirement] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [previousPath, setPreviousPath] = React.useState(
    sessionStorage.getItem("previousPath") || "/"
  );
  const navigate = useNavigate();
  const location = useLocation();

  const redirectToFirstTab = (loannum: string, closeTabType: string = "") => {
    // console.log("redirectToFirstTab===>", loannum);
    console.log("redirectToFirstTab===>closeTabType===>", closeTabType);
    console.log(
      "redirectToFirstTab ===> openGlobalTabs lenght===>",
      openGlobalTabs.length
    );
    const firstTabId = openGlobalTabs[0];
    if (firstTabId) {
      let moveTabArr = firstTabId.split("-");
      let moveTabType = moveTabArr[0];
      let moveTabId = moveTabArr[1];
      let moveTabLoanNum = "";

      // 有的是这种格式，loannum中有-， app-xxxx-yyyyyy-ccc
      if (moveTabArr.length >= 3) {
        moveTabLoanNum = moveTabArr.slice(2).join("-");
      }

      let redirectLoanNum = moveTabLoanNum;
      // console.log("xxxxxxxxxxxxxx moveTabType===>", moveTabType);
      // console.log("xxxxxxxxxxxxxx moveTabLoanNum===>", moveTabLoanNum);
      // console.log("xxxxxxxxxxxxxx redirectLoanNum===>", redirectLoanNum);
      if (moveTabType == "app") {
        navigate(
          `/applicationSummary/` +
            moveTabId +
            (redirectLoanNum ? "?loannum=" + redirectLoanNum : "")
        );
      } else if (moveTabType == "loan") {
        navigate(
          `/loanSummary/` +
            moveTabId +
            (redirectLoanNum ? "?loannum=" + redirectLoanNum : "")
        );
      } else if (moveTabType == "user") {
        navigate(`/userSummary/` + moveTabId);
      }
    } else {
      if (closeTabType == "app") {
        navigate(
          '/applications?filter={"status":"New","subStatus":"Verification Pending"}'
        );
      } else if (closeTabType == "loan") {
        navigate(
          '/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}'
        );
      } else if (closeTabType == "customer") {
        navigate('/customers?filter={"status":"signUp2026_campaigns"}');
      } else {
        navigate("/");
      }
    }
  };
  const queryParams = new URLSearchParams(location.search);
  let reqLoanNum = queryParams.get("loannum");
  reqLoanNum = reqLoanNum ? reqLoanNum : "";
  // console.log("xxxxxx===>reqLoanNum===>", reqLoanNum);
  let closeTabType = "";
  const match = useMatch("/applicationSummary/:id");
  let activeAppId = match ? match.params.id : null;
  closeTabType = match ? "app" : "";
  const matchloan = useMatch("/loanSummary/:id");
  let activeLoanId = matchloan ? matchloan.params.id : null;
  closeTabType = matchloan ? "loan" : closeTabType;
  const matchuser = useMatch("/userSummary/:id");
  let activeUserId = matchuser ? matchuser.params.id : null;
  closeTabType = matchuser ? "customer" : closeTabType;

  useEffect(() => {
    if (!removeGlobalTabName) return;

    const isCurrentTab =
      (activeAppId &&
        removeGlobalTabName == "app-" + activeAppId + "-" + reqLoanNum) ||
      (activeLoanId &&
        removeGlobalTabName == "loan-" + activeLoanId + "-" + reqLoanNum) ||
      (activeUserId &&
        removeGlobalTabName == "user-" + activeUserId + "-" + reqLoanNum);

    if (isCurrentTab) {
      removeGlobalTab(removeGlobalTabName);
      // 跳转到对应列表页
      if (closeTabType == "app") {
        navigate(
          '/applications?filter={"status":"New","subStatus":"Verification Pending"}'
        );
      } else if (closeTabType == "loan") {
        navigate(
          '/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}'
        );
      } else if (closeTabType == "customer") {
        navigate('/customers?filter={"status":"signUp2026_campaigns"}');
      } else {
        navigate("/");
      }
    } else {
      // 关闭非当前tab，只关闭，不跳转
      removeGlobalTab(removeGlobalTabName);
    }

    setRemoveGlobalTabName("");
  }, [
    removeGlobalTabName,
    activeAppId,
    activeLoanId,
    activeUserId,
    reqLoanNum,
    closeTabType,
    removeGlobalTab,
    setRemoveGlobalTabName,
    openGlobalTabs,
    navigate,
  ]);

  useEffect(() => {
    const openTabTotal = openGlobalTabs.length;
    if (openTabTotal >= 7) {
      errorNotify("Cannot open more than 6 tabs.");
      navigate("/#");
      return;
    }

    // 如果正在关闭tab（removeGlobalTabName存在且等于当前tabKey），不自动添加tab，避免刚关掉又加回来
    if (activeAppId && parseInt(activeAppId) > 0) {
      const tabKey = "app-" + activeAppId + "-" + reqLoanNum;
      if (removeGlobalTabName === tabKey) return;
      if (!openGlobalTabs.includes(tabKey)) {
        addGlobalTab(tabKey);
      }
    }

    if (activeLoanId && parseInt(activeLoanId) > 0) {
      const tabKey = "loan-" + activeLoanId + "-" + reqLoanNum;
      if (removeGlobalTabName === tabKey) return;
      if (!openGlobalTabs.includes(tabKey)) {
        addGlobalTab(tabKey);
      }
    }

    if (activeUserId && parseInt(activeUserId) > 0) {
      const tabKey = "user-" + activeUserId + "-" + reqLoanNum;
      if (removeGlobalTabName === tabKey) return;
      if (!openGlobalTabs.includes(tabKey)) {
        addGlobalTab(tabKey);
      }
    }
  }, [
    openGlobalTabs,
    activeAppId,
    activeLoanId,
    activeUserId,
    reqLoanNum,
    addGlobalTab,
    errorNotify,
    navigate,
    removeGlobalTabName,
  ]);

  useEffect(() => {
    const handleLocationChange = () => {
      sessionStorage.setItem("previousPath", window.location.pathname);
    };
    window.addEventListener("popstate", handleLocationChange);
    return () => window.removeEventListener("popstate", handleLocationChange);
  }, []);

  let pathname = location.pathname;
  pathname = pathname.replace("/", "");

  let mainpathname = "/";
  if (
    pathname.includes("applicationSummary") ||
    pathname.includes("userSummary") ||
    pathname.includes("loanSummary")
  ) {
    mainpathname = "/";
  } else {
    mainpathname = pathname;
    localStorage.setItem("mainpathname", mainpathname);
  }
  const isSummaryRoute =
    pathname.includes("applicationSummary") ||
    pathname.includes("userSummary") ||
    pathname.includes("loanSummary");

  const currentSummaryTabKey = activeAppId
    ? "app-" + activeAppId + "-" + reqLoanNum
    : activeLoanId
    ? "loan-" + activeLoanId + "-" + reqLoanNum
    : activeUserId
    ? "user-" + activeUserId + "-" + reqLoanNum
    : "";

  const renderedOpenGlobalTabs =
    currentSummaryTabKey && !openGlobalTabs.includes(currentSummaryTabKey)
      ? [...openGlobalTabs, currentSummaryTabKey]
      : openGlobalTabs;

  useEffect(() => {}, [openGlobalTabs]);

  // const email = localStorage.getItem("email");
  // const isLoggedIn = email ? true : false;
  const username = localStorage.getItem("username");
  const isLoggedIn = username ? true : false;
  return (
    <Core className={clsx("layout", className)} {...rest}>
      <SkipNavigationButton />
      <div className={LayoutClasses.appFrame}>
        {isLoggedIn && <AppBar alwaysOn={appBarAlwaysOn} />}

        <main className={LayoutClasses.contentWithSidebar}>
          {isLoggedIn && (
            <Sidebar appBarAlwaysOn={appBarAlwaysOn}>
              <Menu />
            </Sidebar>
          )}
          <div
            id="main-content"
            className={LayoutClasses.content}
            style={{ backgroundColor: "#f8f9f9" }}
          >
            <div className="tabBody">
              {isSummaryRoute ? (
                <CustomTabbedForm
                  key="appTabbedform"
                  component={TabbedFormContainer}
                  toolbar={false}
                  onSubmit={() => {}}
                  mode="onBlur"
                  sanitizeEmptyValues={false}
                >
                  <CustomTabbedFormTab
                    key="main-page"
                    label="Main"
                    path={mainpathname}
                    value={mainpathname}
                  >
                    <ErrorBoundary
                      onError={handleError}
                      fallbackRender={({ error, resetErrorBoundary }) => (
                        <div
                          style={{
                            padding: 32,
                            textAlign: "center",
                            color: "#c00",
                          }}
                        >
                          <h2>Something went wrong.</h2>
                          <pre
                            style={{
                              color: "#888",
                              fontSize: 14,
                              whiteSpace: "pre-wrap",
                              textAlign: "left",
                              maxWidth: 800,
                              margin: "16px auto",
                            }}
                          >
                            {error?.message}
                            {"\n\n"}
                            {error?.stack}
                          </pre>
                          <button
                            onClick={resetErrorBoundary}
                            style={{ marginTop: 16 }}
                          >
                            Try Again
                          </button>
                        </div>
                      )}
                    >
                      <Suspense fallback={<Loading />}>{children}</Suspense>
                    </ErrorBoundary>
                  </CustomTabbedFormTab>
                  {renderedOpenGlobalTabs.map((curTab) => {
                    let tabarr = curTab.split("-");
                    let tabtype = tabarr[0];
                    let tabId = tabarr[1];
                    let tabLoanNum = tabarr[2] ? tabarr[2] : "";
                    if (tabtype == "app") {
                      return (
                        <CustomTabbedFormTab
                          key={`app_tab_` + tabId}
                          label="App Tab Not Need Show"
                          path={`applicationSummary/` + tabId}
                          value={`applicationSummary/` + tabId}
                          className="HideTabHeader"
                          sx={{ display: "none" }}
                        >
                          <Grid container>
                            <div
                              id={`appshow_` + tabId}
                              style={{ width: "100%" }}
                            >
                              <ApplicationSummaryTabShowBody appId={tabId} />
                            </div>
                          </Grid>
                        </CustomTabbedFormTab>
                      );
                    } else if (tabtype == "loan") {
                      return (
                        <CustomTabbedFormTab
                          key={`loan_tab_` + tabId}
                          label="Loan Tab Not Need Show"
                          path={`loanSummary/` + tabId}
                          value={`loanSummary/` + tabId}
                          className="HideTabHeader"
                          sx={{ display: "none" }}
                        >
                          <Grid container>
                            <div
                              id={`appshow_` + tabId}
                              style={{ width: "100%" }}
                            >
                              <LoanSummaryTabShowBody appId={tabId} />
                            </div>
                          </Grid>
                        </CustomTabbedFormTab>
                      );
                    } else if (tabtype == "user") {
                      return (
                        <CustomTabbedFormTab
                          key={`user_tab_` + tabId}
                          label="User Tab Not Need Show"
                          path={`userSummary/` + tabId}
                          value={`userSummary/` + tabId}
                          className="HideTabHeader"
                          sx={{ display: "none" }}
                        >
                          <Grid container>
                            <div
                              id={`appshow_` + tabId}
                              style={{ width: "100%" }}
                            >
                              <CustomerSummaryTabShowBody userId={tabId} />
                            </div>
                          </Grid>
                        </CustomTabbedFormTab>
                      );
                    }
                  })}
                </CustomTabbedForm>
              ) : (
                <ErrorBoundary
                  onError={handleError}
                  fallbackRender={({ error, resetErrorBoundary }) => (
                    <Error
                      error={error}
                      errorComponent={errorComponent}
                      errorInfo={errorInfo}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                >
                  <Suspense fallback={<Loading />}>{children}</Suspense>
                </ErrorBoundary>
              )}
            </div>
          </div>
        </main>

        <Inspector />
      </div>
    </Core>
  );
};

export interface LayoutProps {
  appBar?: ComponentType<AppBarProps>;
  appBarAlwaysOn?: boolean;
  className?: string;
  children: React.ReactNode;
  error?: ComponentType<ErrorProps>;
  menu?: ComponentType<MenuProps>;
  sidebar?: ComponentType<SidebarProps>;
  sx?: SxProps;
}

export interface LayoutState {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

const PREFIX = "RaLayout";
export const LayoutClasses = {
  appFrame: `${PREFIX}-appFrame`,
  contentWithSidebar: `${PREFIX}-contentWithSidebar`,
  content: `${PREFIX}-content`,
};

const Core = styled("div", {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  zIndex: 1,
  height: "100%",
  minHeight: "100%",
  backgroundColor: theme.palette.background.default,
  position: "relative",
  minWidth: "fit-content",
  width: "100%",
  color: theme.palette.getContrastText(theme.palette.background.default),

  [`& .${LayoutClasses.appFrame}`]: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(7),
    },
  },
  [`& .${LayoutClasses.contentWithSidebar}`]: {
    display: "flex",
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  [`& .${LayoutClasses.content}`]: {
    backgroundColor: theme.palette.background.default,
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexBasis: 0,
    padding: 0,
    [theme.breakpoints.up("xs")]: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
  },
}));
